/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

const parser = require('./parser.js');
const ast = require('./ast.js');
const emitter = require('./emitter.js');
const isa = require('./isa.js');



// TODO These correspond to frequency set, need to make a common list
const ONCE = 1;
const MONTHLY = 2;
const BIMONTHLY = 3;
const QUARTERLY = 4;
const SEMIYEARLY = 5;
const WEEKLY = 10;
const BIWEEKLY = 12;
const FIRSTFIFTEEN = 15;
const FIFTEENLAST = 16;
const YEARLY = 20;
const TWOYEAR = 21;
const THREEYEAR = 22;
const FOURYEAR = 23;
const FIVEYEAR = 24;


const daily = 1;
const monthly = 2;
const yearly = 3;
const firstfifteen = 4;


function makeType(t,i) {
  let obj = {
    type: t,
    int: i,
  }

  return obj;
}


function convertFreq(f) {
  switch ( f ) {
    case MONTHLY:
      return makeType(monthly, 1);
      break;
    case BIWEEKLY:
      return makeType(daily, 14);
      break;
    case WEEKLY:
      return makeType(daily, 7);
      break;
    case BIMONTHLY:
      return makeType(monthly, 2);
      break;
    case FIFTEENLAST:
      return makeType(firstfifteen, 1);
      break;
    case QUARTERLY:
      return makeType(monthly, 3);
      break;
    case SEMIYEARLY:
      return makeType(monthly, 6);
      break;
    //case "FirstAndFifteen":
    //    next_date = FirstAndFifteen( date );
    //  break;
    case YEARLY:
      return makeType(yearly, 1);
      break;
    case TWOYEAR:
      return makeType(yearly, 2);
      break;
    case THREEYEAR:
      return makeType(yearly, 3);
      break;
    case FOURYEAR:
      return makeType(yearly, 4);
      break;
    case FIVEYEAR:
      return makeType(yearly, 5);
      break;
    default:
      return makeType(daily, 1);
  } // switch freq

}

const reg_days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const leap_days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const tot_reg_days = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
const tot_leap_days = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
const month_lookup = [0, 3, 3, 6, 1, 4, 6, 2, 5, 0, 3, 5];
const century_lookup = [4, 2, 0, 6, 4, 2, 0]; // 1700 is base

class Generator {
  constructor() {
    this.days = reg_days;
    this.parser = new parser.Parser();

    this.rules = [];
    this.ruleSet = [];

    this.freq = 0; // Y, M, D
    this.interval = 1;

    this.proposed = 0;
    this.actual = 0;
    this.final = 0;

    this.year = 0;
    this.month = 0;
    this.day = 0;
    this.week = 0;
    this.startingDOW = 0;
    this.isLeap = false;

    this.isFirst = true; // only used in advance for the first call
    this.isNewYear = false; // set to true on the first tick of every new year
    this.tick = 0; // temp until using dates

    this.cpu = new executer3();
  }


  registerRule(source) {
    let result = {
      error: false,
      message: "",
      id: 0,
      block: []
    }


    let res = this.parser.parseRule(source); // res is the AST result
  
    if (res.error) {
      return res;
    }

    let block_res = emitter.emitter(res);
    if (block_res.error) {
      return block_res;
    }

    result.block = block_res.buf;

    result.id = this.rules.length;
    this.rules.push(result);

    return result;
  }


  addRuleId(rule) {
    this.ruleSet.push(rule);
  }


  init(config) {
    let f = convertFreq(config.freq);
    this.freq = f.type;
    this.interval = f.int;

    this.year = config.startDate.getFullYear();
    this.month = config.startDate.getMonth(); // base 0
    this.day = config.startDate.getDate();
    this.week = 0;
    this.isLeap = this.isLeapYear(this.year);
    this.startingDOW = this.calcDOW(this.year, this.mmonth, this.day, this.isLeap);
    this.days = this.isLeap ? leap_days : reg_days;
    this.curDateNum = 0;

    let e = config.endDate;
    this.endDateNum = e.getFullYear() * 10000 + (e.getMonth()+1)*100 + e.getDate();

    //console.log(config);
    this.ruleSet = [];

    this.proposed = config.amount;
    this.actual = this.proposed;

    this.isOnce = config.freq === ONCE;
    this.isFirst = true;
    this.isNewYear = false;
    this.tick = 0;
  }


  advance() {
    if (this.isOnce && !this.isFirst) {
      return false;
    }

    if (!this.isFirst) {
      this.calcNextDate();
    }
    this.isFirst = false;
    this.curDateNum = this.year * 10000 + (this.month+1)*100 + this.day;
    if (this.curDateNum > this.endDateNum) {
      return false;
    }


    this.final = this.actual;

    if (this.ruleSet.length === 0) {
      return true;
    }

    // apply rules
    // executer1 12-15ms
    // executer2 5-8ms had to comment out old block
    //this.amount = executer3(this.rules[0].buf,this);
    const rule = this.rules[this.ruleSet[0]].expr;

    // At this time the expressions are just numbers so ref the AST directly
    // if the expr is more complex, then we will use the cpu
    let val = 0;
    if (rule.nodeType === ast.NODETYPE_NUMBER) {
      val = rule.numVal;
    } else {
      val = null;
    }

    if (rule.type === ast.MODTYPE_INCREASE) {
      this[rule.target] += val;
    } else if (rule.type === ast.MODTYPE_DECREASE) {
      this[rule.target] -= val;
    } else { // MODTYPE_SET
      this[rule.target] = val;
    }

    
    this.cpu.run(rule.block, this);

    return true;
  }


  getCurISOWeekNum() {
    return this.calcISOWeekNum( this.year, this.month, this.day );
  }

  /**
   * Given year month and date where month = 0-11, day 1-31
   * @param {*} year 
   * @param {*} month 
   * @param {*} day 
   * @returns day of week where Sun = 0 .. Sat = 6
   */
  calcDOW(year, month, day, leap) {
    let lc = (leap && (month === 0 || month === 1 ) === true ? 1 : 0 );

    let cen = (year / 100) >> 0;
    let yy = year - 100*cen;

    let cc = century_lookup[cen-17];
    let yc = (yy + ((yy / 4)>>0) ) % 7;
    let mc = month_lookup[month];
    

    return ( cc + yc + mc + day - lc ) % 7;
  }


  /**
  * Given year month and date where month = 0-11, day 1-31
  * @param {*} year 
  * @param {*} month 
  * @param {*} day 
  * @returns weeknum where Mon = 0 .. Sun = 6 
  * 
  * https://webspace.science.uu.nl/~gent0113/calendar/isocalendar_text_5.htm
  */
  calcISOWeekNum(year, month, day) {
    function gregdaynumber(yy, mm, dd) {
      // computes the day number since 0 January 0 CE (Gregorian)
         
      let y = yy;
      let m = mm;
      if (mm < 3) y=y-1;
      if (mm < 3) m=m+12;
    
      return Math.floor(365.25*y)-Math.floor(y/100)+Math.floor(y/400)+Math.floor(30.6*(m+1))+dd-62;
    }
      

    let leap = this.isLeapYear(year);
    let wday = this.calcDOW( year, month, day, leap );
       
    let weekday=((wday+6)%7)+1; // weekdays will be numbered 1 to 7
       
    let isoyear=year;
      
    let d0=gregdaynumber(year,1,0);
    let weekday0=( (d0+4)%7)+1;
      
    let d=gregdaynumber(year,month+1,day);
    let isoweeknr=Math.floor((d-d0+weekday0+6)/7)-Math.floor((weekday0+3)/7);
      
    // check whether the last few days of December belong to the next year's ISO week
      
    if ((month == 11) && ((day-weekday) > 27)) {
      isoweeknr=1;
      isoyear=isoyear+1;
    }
      
    // check whether the first few days of January belong to the previous year's ISO week
      
    if((month == 0) && ((weekday-day) > 3)){
      d0=gregdaynumber(year-1,1,0);
      weekday0=((d0+4)%7)+1;
      isoweeknr=Math.floor((d-d0+weekday0+6)/7)-Math.floor((weekday0+3)/7);
      isoyear=isoyear-1;
    }

    return isoweeknr;
    /*    
    return {
      isoyear,
      isoweeknr,
      weekday  
    }
    */
    //if(isoweeknr < 10) return isoyear+"-W0"+isoweeknr+"-"+weekday;
  }
    

  /**
   * Given year month and date where month = 0-11, day 1-31
   * @param {*} year 
   * @param {*} month 
   * @param {*} day 
   * @returns weeknum where Mon = 0 .. Sun = 6 
   */
  calcWeeknum2(year, month, day) {
    let m = [6, 0, 1, 2, 3, 4, 5]; // Map DOW to ISO DOW
    let is_leap = this.isLeapYear(year);
    let dow = this.calcDOW(year, 0, 1, is_leap);
    let prev_leap = this.isLeapYear(year-1);

    //let adj = 7 - m[dow] + 1;
    let adj = m[dow];

    let days = ( !is_leap ? tot_reg_days[month] : tot_leap_days[month] ) + day;
    let diff = 0;

    if ( month === 0 ) { // Jan
      if ( dow === 0 && day === 1 ) { // Sun
        return 52;
      } else if ( dow === 6 && ( day === 1 || day === 2 ) ) { // Sat
        return prev_leap ? 53 : 52;
      } else if ( dow === 5 && ( day >= 1 && day <= 3 ) ) { // Fri
        return 53;
      } else if ( dow === 4 && ( day >= 1 && day <= 4 ) ) { // Thu
        return 1;
      } else if ( dow === 3 && ( day >= 1 && day <= 5 ) ) { // Wed
        return 1;
      } else if ( dow === 2 && ( day >= 1 && day <= 6 ) ) { // Tue
        return 1;
      } else if ( dow === 1 && ( day >= 0 && day <= 6 ) ) { // Mon
        return 1;
      }

      // else falls through
    } else if ( month === 11 ) { // Dec
      if ( dow === 0 && ( day === 25 || day === 31 ) ) { // Sun
        return is_leap && day === 31 ? 1 : 52;
      } else if ( dow === 6 && ( day >= 25 || day <= 31 ) ) { // Sat
        return 52; 
      } else if ( dow === 5 && ( day >= 26 && day <= 31 ) ) { // Fri
        return 52;
      } else if ( dow === 4 && ( day >= 27 && day <= 31 ) ) { // Thu
        return 53;
      } else if ( dow === 3 && ( day >= 28 && day <= 31 ) ) { // Wed
        return is_leap ? 53 : 1;
      } else if ( dow === 2 && ( day >= 29 && day <= 31 ) ) { // Tue
        return 1;
      } else if ( dow === 1 && ( day >= 30 && day <= 31 ) ) { // Mon
        return 1;
      }
    } 

    //console.log( year.toString() + '  ' + month.toString() + '  ' + day.toString()  + '  ' + dow.toString() + '  ' + days.toString());
    let x = dow === 5 || ( dow === 5 && prev_leap ) ? -1 : 0;
    return (( days + adj - 1 ) / 7>>0 ) + 1 + x;
  }


  // Returns true if the current date is <= stop date
  curDateInRange() {
    return this.curDateNum <= this.endDateNum; 
  }


  isLeapYear(year) {
    if (year % 100 === 0) {
      return year % 400 === 0;
    }

    return year % 4 === 0;
  }


  calcNextDate() {
    this.tick++; // start/stop

    if (this.freq === monthly) {
      this.month += this.interval;
      if (this.day > this.days[this.month]) {
        this.day = this.days[this.month]; // eg 31 -> 30 
      }
    } else if (this.freq === daily) {
      this.day += this.interval;
    } else if (this.freq === yearly) {
      this.year += this.interval;
      this.isLeap = this.isLeapYear(this.year);
    } else {
      if (this.day == 15) {
        this.day = this.days[this.month];
      } else {
        this.month++;
        this.day = 15;
      }
    }

    if (this.day>this.days[this.month]) {
      this.day = this.day - this.days[this.month];
      this.month++;
    }

    this.isNewYear = false;
    if (this.month > 11) {
      this.month = this.month - 12; // TODO handle months > 12 which requires years
      this.year++;
      this.isNewYear = true;
      this.isLeap = this.isLeapYear(this.year);
      this.days = this.isLeap ? leap_days : reg_days;
    }
  }


}

module.exports.Generator = Generator;



function executer(block,data) {
  //let stack = [null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];
  let stack = [];
  let count = 0;
  let v1 = null;
  let v2 = null;
  let v3 = null;
  let cur = block[0];


  let op = [
    { i: (d) => {} },
    { i: (d) => { stack.push(d); } },
    { i: (d) => { stack.push(data[d]); } },
    { i: (d) => { v1 = stack.pop(); v2 = stack.pop(); alu[d].i(); } }
  ];

  let alu = [
    { i: (d) => {} },
    { i: (d) => { stack.push( v1 && v2 ); } }, 
    { i: (d) => { stack.push( v1 || v2 ); } }, 
    { i: (d) => { stack.push( v1 === v2 ); } },
    { i: (d) => { stack.push( v1 !== v2 ); } },
    { i: (d) => { stack.push( v1 < v2 ); } },
    { i: (d) => { stack.push( v1 <= v2 ); } },
    { i: (d) => { stack.push( v1 > v2 ); } },
    { i: (d) => { stack.push( v1 >= v2 ); } },
    { i: (d) => { stack.push( v1 + v2 ); } },
    { i: (d) => { stack.push( v1 - v2 ); } },
    { i: (d) => { stack.push( v1 * v2 ); } },
    { i: (d) => { stack.push( v1 / v2 ); } },
  ];
/*
  let op = [
    { i: (d) => {} },
    { i: (d) => { push(d); } },
    { i: (d) => { push(data[d]); } },
    { i: (d) => { v1 = pop(); v2 = pop(); alu[d].i(); } } // handleBinary(d);
  ];

  let alu = [
    { i: (d) => {} },
    { i: (d) => { push( v1 && v2 ); } }, 
    { i: (d) => { push( v1 || v2 ); } }, 
    { i: (d) => { push( v1 === v2 ); } },
    { i: (d) => { push( v1 !== v2 ); } },
    { i: (d) => { push( v1 < v2 ); } },
    { i: (d) => { push( v1 <= v2 ); } },
    { i: (d) => { push( v1 > v2 ); } },
    { i: (d) => { push( v1 >= v2 ); } },
    { i: (d) => { stack[count] = ( v1 + v2 ); count++;} },
    { i: (d) => { push( v1 - v2 ); } },
    { i: (d) => { push( v1 * v2 ); } },
    { i: (d) => { push( v1 / v2 ); } },
  ];

  function push(d) {
    stack[count] = d;
    count++;
  }

  function pop() {
    // if count = 0
    count--;
    return stack[count];
  }
*/

  function handleBinary(op) {
//    v1 = stack.pop(); 
//    v2 = stack.pop();
    v1 = pop(); 
    v2 = pop();
    
    alu[op].i();
  }


  for (let i=0; i<block.length; i++) {
    cur=block[i];
    op[cur.op].i(cur.data);
    //console.log(block[i]);
  }

  return stack.pop();

}


function executer2(block,data) {
  let stack = [];
  let v1 = null;
  let v2 = null;
  let cur = block[0];

/*
  let op = [
    { i: (d) => {} },
    { i: (d) => { stack.push(d); } },
    { i: (d) => { stack.push(data[d]); } },
    { i: (d) => { v1 = stack.pop(); v2 = stack.pop(); alu[d].i(); } }
  ];

  let alu = [
    { i: (d) => {} },
    { i: (d) => { stack.push( v1 && v2 ); } }, 
    { i: (d) => { stack.push( v1 || v2 ); } }, 
    { i: (d) => { stack.push( v1 === v2 ); } },
    { i: (d) => { stack.push( v1 !== v2 ); } },
    { i: (d) => { stack.push( v1 < v2 ); } },
    { i: (d) => { stack.push( v1 <= v2 ); } },
    { i: (d) => { stack.push( v1 > v2 ); } },
    { i: (d) => { stack.push( v1 >= v2 ); } },
    { i: (d) => { stack.push( v1 + v2 ); } },
    { i: (d) => { stack.push( v1 - v2 ); } },
    { i: (d) => { stack.push( v1 * v2 ); } },
    { i: (d) => { stack.push( v1 / v2 ); } },
  ];
*/

  for (let i=0; i<block.length; i++) {
    const op = block[i].op;
    const d = block[i].data;
    

    if (op===1) {
      stack.push(d);
    } else if (op===2) {
      stack.push(data[d]);
    } else {
      v1 = stack.pop(); 
      v2 = stack.pop();

      if (d===9) {
        stack.push( v1 + v2 ); 
      }
    }
  }

  return stack.pop();

}


class executer3 {
  constructor() {
    this.stack = [];
    this.v1 = null;
    this.v2 = null;
    this.ip = 0;
    this.data = null;

  
    this.op = [
      { i: (d,t) => {} }, // NOP
      { i: (d,t) => { t.stack.push(d); } }, // PUSH_VAL
      { i: (d,t) => { t.stack.push(t.data[d]); } }, // PROC_BINARY
      { i: (d,t) => { t.v1 = t.stack.pop(); t.v2 = t.stack.pop(); t.alu[d].i(t); } } // PROC_BINARY
    ];
    
    this.alu = [
      { i: (t) => {} },
      { i: (t) => { t.stack.push( t.v1 && t.v2 ); } }, 
      { i: (t) => { t.stack.push( t.v1 || t.v2 ); } }, 
      { i: (t) => { t.stack.push( t.v1 === t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 !== t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 < t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 <= t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 > t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 >= t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 + t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 - t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 * t.v2 ); } },
      { i: (t) => { t.stack.push( t.v1 / t.v2 ); } },
    ];
  }


  run(block, data) {
    this.data = data;

    for (let i=0; i<block.length; i++) {
      const cur=block[i];
      this.op[cur.op].i(cur.data, this);
      //console.log(block[i]);
    }

    return this.stack.pop();
  
  }

}

